import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M7.04 0a.8.8 0 0 1 .8.8v2.4a.8.8 0 1 1-1.6 0V.8a.8.8 0 0 1 .8-.8m0 12a.8.8 0 0 1 .8.8v2.4a.8.8 0 1 1-1.6 0v-2.4a.8.8 0 0 1 .8-.8m6.929-8a.8.8 0 0 1-.293 1.093l-2.079 1.2a.8.8 0 1 1-.8-1.386l2.079-1.2A.8.8 0 0 1 13.969 4M3.577 10a.8.8 0 0 1-.294 1.093l-2.078 1.2a.8.8 0 1 1-.8-1.386l2.078-1.2A.8.8 0 0 1 3.577 10m10.392 2a.8.8 0 0 1-1.093.293l-2.079-1.2a.8.8 0 0 1 .8-1.386l2.079 1.2A.8.8 0 0 1 13.969 12M3.577 6a.8.8 0 0 1-1.094.293l-2.078-1.2a.8.8 0 1 1 .8-1.386l2.078 1.2A.8.8 0 0 1 3.577 6"
    }, null, -1)
  ]))]))
}
export default { render: render }